<template>
  <div
    class="absolute bottom-0 origin-[center_bottom] cursor-default text-sm text-txt opacity-100"
    @click.stop
    @dblclick.stop
    @touchstart.stop
    @touchmove.stop
    @touchend.stop
    @mousedown.stop
    @mousemove.stop
    @mouseup.stop
  >
    <div class="relative rounded-lg border border-brd shadow">
      <RedesignAccomCard
        v-if="accommodation || loading"
        :key="accommodation?.code"
        class="relative border-0 z-2"
        :class="{ 'rounded-b-none': count > 1 }"
        :accom="accommodation"
        :trip
        :vertical
        :compact
        :loading
        :cta
        @close="close"
      />
      <footer
        v-if="count > 1"
        class="flex flex-row justify-between bg-bgr border-0 border-brd border-t rounded-b-lg"
      >
        <nav class="flex w-full flex-row items-center justify-between">
          <button
            class="group flex px-4 flex-1 items-center justify-end h-full focus:outline-none"
            @click="prevAccommodation"
          >
            <span
              class="flex p-2 rounded-full group-hover:bg-bgr-100 group-focus:ring-2 group-focus:ring-offset-2 group-active:bg-bgr-100"
            >
              <WebccIcon
                name="site/chevron-right-bold"
                class="h-4 w-4 rotate-180"
                filled
              />
            </span>
          </button>
          <span class="flex-initial py-4">
            <span>
              {{ currentIndex + 1 }}/{{ $t(`${trPrefix}objects`, count) }}
            </span>
          </span>
          <button
            class="group flex px-4 flex-1 items-center justify-start h-full focus:outline-none"
            @click="nextAccommodation"
          >
            <span
              class="flex p-2 rounded-full group-hover:bg-bgr-100 group-focus:ring-2 group-focus:ring-offset-2 group-active:bg-bgr-100"
            >
              <WebccIcon
                name="site/chevron-right-bold"
                class="h-4 w-4"
                filled
              />
            </span>
          </button>
        </nav>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.views.search.InfoWindowLegacy.'

const currentIndex = ref(0)

const props = defineProps<{
  trip: Partial<TripParams>
  accommodations: ResultDocument[]
  vertical?: boolean
  compact?: boolean
  loading?: boolean
  cta?: boolean
}>()

const emit = defineEmits<{ (e: 'close'): void }>()

const accommodation = computed(() => props.accommodations?.[currentIndex.value])
const count = computed(() => props.accommodations?.length ?? 0)

watch(
  () => props.accommodations,
  () => (currentIndex.value = 0),
)

function nextAccommodation() {
  currentIndex.value = ++currentIndex.value % count.value
}

function prevAccommodation() {
  currentIndex.value += currentIndex.value ? -1 : count.value - 1
}

function close() {
  emit('close')
}
</script>
